import React from 'react'
import { withScope, captureException } from '@sentry/browser'

const style = { color: '#F44336', fontSize: 20, paddingBottom: 20 }

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true, errorMsg: error.message }
  }

  componentDidCatch(error, errorInfo) {
    if (
      typeof window === 'undefined' ||
      new URL(window.location.href).host.includes('localhost')
    ) {
      return
    }

    // https://docs.sentry.io/platforms/javascript/react/#error-boundaries
    withScope((scope) => {
      scope.setExtras(errorInfo)
      const eventId = captureException(error)
      this.setState({ eventId })
    })
  }

  render() {
    const { hasError, errorMsg, errorStack } = this.state

    if (hasError) {
      return (
        <div className="box main-panel">
          <div style={style}>Something went wrong.</div>
          {errorMsg && (
            <p>
              <b>{errorMsg}</b>
            </p>
          )}
          {errorStack && <p>{errorStack}</p>}
        </div>
      )
    }

    return this.props.children
  }
}
